import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "display-flex ion-justify-content-center" }
const _hoisted_2 = { class: "display-flex ion-justify-content-center ion-padding" }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "display-flex ion-justify-content-center ion-padding-bottom" }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "display-flex ion-justify-content-center ion-padding-bottom" }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { class: "display-flex ion-justify-content-center ion-padding-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_minified_vocabulary = _resolveComponent("minified-vocabulary")!
  const _component_end_of_list = _resolveComponent("end-of-list")!
  const _component_network_error = _resolveComponent("network-error")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_settings = _resolveComponent("settings")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "Vocabularies",
        "content-id": "vocabulary-list",
        "menu-id": "vocabulary-list-menu",
        "enable-searching": true,
        "search-placeholder": "Search in vocabularies",
        "search-keyword": _ctx.searchKeyword,
        "set-search-keyword": _ctx.setSearchKeyword,
        "enable-settings": true,
        "modify-settings": _ctx.openSettingsPopover
      }, null, 8, ["search-keyword", "set-search-keyword", "modify-settings"]),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "vocabulary-list"
      }, {
        default: _withCtx(() => [
          (_ctx.shouldDisplayFetchButton())
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "display-flex ion-justify-content-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    sizeXs: "12",
                    sizeSm: "12",
                    sizeMd: "10",
                    sizeLg: "8",
                    sizeXl: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { class: "margin-top-unset" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createElementVNode("view", _hoisted_1, [
                                _createVNode(_component_lottie_animation, {
                                  class: "announcement-animation",
                                  "animation-data": _ctx.emptyVocabulariesAnimation,
                                  loop: true
                                }, {
                                  fallback: _withCtx(() => [
                                    _createVNode(_component_ion_item, { lines: "none" }, {
                                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("span", { class: "material-icons firecracker-primary-color-icon-large" }, " campaign ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["animation-data"])
                              ]),
                              _createVNode(_component_ion_card_subtitle, { class: "ion-text-center ion-padding" }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode(" Looks like you do not have any vocabulary in your cohort yet! We can generate a few if you wish. All you need is to click the button below and wait a bit! And FYI, you may remove those later. ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("view", _hoisted_2, [
                                _createVNode(_component_ion_item, { lines: "none" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      onClick: _ctx.bootstrap,
                                      size: "large"
                                    }, {
                                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode(" Fetch ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showSpinner)
            ? (_openBlock(), _createBlock(_component_spinner, { key: 1 }))
            : _createCommentVNode("", true),
          (_ctx.shouldDisplayNoSearchResultMessage())
            ? (_openBlock(), _createElementBlock("view", _hoisted_3, [
                _createVNode(_component_ion_card_subtitle, { class: "ion-padding ion-text-center" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`No vocabulary was found for "${_ctx.searchKeyword}". ${
                            !_ctx.fetchFlashcard || !_ctx.fetchNotHavingDefinitionOnly
                                ? `You may get better search results if you change your filtering preference.`
                                : ``
                        }`), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("view", _hoisted_4, [
                  _createVNode(_component_lottie_animation, {
                    class: "empty-search-animation",
                    "animation-data": _ctx.emptySearchAnimation,
                    loop: true
                  }, {
                    fallback: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("span", { class: "material-icons firecracker-primary-color-icon-large" }, " manage_search ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["animation-data"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shouldDisplayEmptyDraftVocabMessage())
            ? (_openBlock(), _createElementBlock("view", _hoisted_5, [
                _createVNode(_component_ion_card_subtitle, { class: "ion-text-center ion-padding" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" No vocabulary was found without definition. " + _toDisplayString(!_ctx.fetchFlashcard
                            ? `However, as "Show flashcard in boxes" is turned off, you may try to find draft vocab by turning on "Show flashcard in boxes".`
                            : ''), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("view", _hoisted_6, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.faThumbsUp,
                    class: "firecracker-primary-color-icon-large"
                  }, null, 8, ["icon"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shouldDisplayEmptyNonFlashcardMessage())
            ? (_openBlock(), _createElementBlock("view", _hoisted_7, [
                _createVNode(_component_ion_card_subtitle, { class: "ion-text-center ion-padding" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" No vocabulary was found that is not in boxes. ", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("view", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.faThumbsUp,
                    class: "firecracker-primary-color-icon-large"
                  }, null, 8, ["icon"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabularies, (vocabulary) => {
            return (_openBlock(), _createBlock(_component_ion_row, {
              key: vocabulary.id,
              class: "display-flex ion-justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  sizeXs: "12",
                  sizeSm: "12",
                  sizeMd: "10",
                  sizeLg: "8",
                  sizeXl: "8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_minified_vocabulary, {
                      vocabulary: vocabulary,
                      "delete-vocabulary": _ctx.disappearVocabularyFromUI,
                      "update-leitner-box-existence": _ctx.updateLeitnerBoxExistence
                    }, null, 8, ["vocabulary", "delete-vocabulary", "update-leitner-box-existence"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (_ctx.isDisabled && _ctx.vocabularies.length > 0 && !_ctx.isNetworkError)
            ? (_openBlock(), _createBlock(_component_end_of_list, {
                key: 5,
                "inline-style": _ctx.cssStyleToClearlyDisplayVocabCountChip
              }, null, 8, ["inline-style"]))
            : _createCommentVNode("", true),
          (_ctx.isNetworkError)
            ? (_openBlock(), _createBlock(_component_network_error, {
                key: 6,
                message: _ctx.errorMessage
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_infinite_scroll, {
            onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (_ctx.renderVocabularies($event))),
            threshold: "100px",
            id: "infinite-scroll",
            disabled: _ctx.isDisabled
          }, {
            default: _withCtx(() => [
              _createVNode(_component_spinner, { "inline-style": _ctx.cssStyleToClearlyDisplayVocabCountChip }, null, 8, ["inline-style"])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_spinner)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_fab, {
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_fab_button, {
                "aria-label": "Create vocabulary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/vocabulary/create')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: _ctx.faPlus }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.totalVocabularies > 0)
            ? (_openBlock(), _createBlock(_component_ion_fab, {
                key: 7,
                vertical: "bottom",
                horizontal: "center",
                slot: "fixed"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_chip, { class: "vocab-count" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(`${_ctx.totalVocabularies} ${_ctx.totalVocabularies > 1 ? 'Vocabs' : 'Vocab'}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isSettingsPopoverOpened)
            ? (_openBlock(), _createBlock(_component_settings, {
                key: 8,
                ref: "VocabSettingsRef",
                "selected-sort": _ctx.selectedSort,
                "close-settings-popover": _ctx.closeSettingsPopover,
                "apply-settings": _ctx.applySettings,
                "on-change-sort": _ctx.onChangeSort,
                "fetch-not-having-definition-only": _ctx.fetchNotHavingDefinitionOnly,
                "fetch-flashcard": _ctx.fetchFlashcard,
                "on-change-fetch-not-having-definition-only": _ctx.onChangeFetchNotHavingDefinitionOnly,
                "on-change-fetch-flashcard": _ctx.onChangeFetchFlashcard,
                "vocabulary-search-coverage": _ctx.vocabularySearchCoverage,
                "on-change-searching-coverage": _ctx.onChangeSearchingCoverage
              }, null, 8, ["selected-sort", "close-settings-popover", "apply-settings", "on-change-sort", "fetch-not-having-definition-only", "fetch-flashcard", "on-change-fetch-not-having-definition-only", "on-change-fetch-flashcard", "vocabulary-search-coverage", "on-change-searching-coverage"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}